import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import { Product } from '../../../interfaces/common/girls_fashion';
import { ErrorResponse } from 'react-router-dom';
import { ApiEndPoints } from '../authentication/api-path';
import { getAPIConfig } from '../authentication/services/get-api-config';

export const addToCart = createAsyncThunk(
  'cartItem/addToCart',
  async (product: Product, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.AddTOCart}`;
      // const { data } = await axios.post(url, product);
      const { data } = await axios.post(url, product, await getAPIConfig());

      if (data.status === 200) {
        return thunkApi.fulfillWithValue(data); // full response (includes message + saved data)
      } else {
        return thunkApi.rejectWithValue(data);
      }
    } catch (e) {
      const error = e as AxiosError<ErrorResponse>;
      if (error.response) {
        return thunkApi.rejectWithValue(error.response.data);
      } else {
        return thunkApi.rejectWithValue('Something went wrong while adding product to cart.');
      }
    }
  }
);

// get all carts api 
export const GetAddedAllCarts = createAsyncThunk(
  'cartItem/getAddedAllCarts',
  async (_, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.GetAllCart}`;
      const { data } = await axios.get(url, await getAPIConfig());

      if (data.status === 200) {
        return thunkApi.fulfillWithValue(data); // just cart items
      } else {
        return thunkApi.rejectWithValue(data);
      }
    } catch (e) {
      const error = e as AxiosError<ErrorResponse>;
      if (error.response) {
        return thunkApi.rejectWithValue(error.response.data);
      } else {
        return thunkApi.rejectWithValue('Something went wrong while fetching cart items.');
      }
    }
  }
);

export const removeFromCart = createAsyncThunk(
  'cartItem/removeFromCart',
  async (productId: string, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.RemoveCardItem}`;

      const { data } = await axios.delete(url, {
        ...await getAPIConfig(),
        data: { productId }, // 💥 Send productId in body
      });

      if (data.status === 200) {
        return thunkApi.fulfillWithValue({ productId, ...data });
      } else {
        return thunkApi.rejectWithValue(data);
      }
    } catch (e) {
      const error = e as AxiosError<ErrorResponse>;
      if (error.response) {
        return thunkApi.rejectWithValue(error.response.data);
      } else {
        return thunkApi.rejectWithValue('Something went wrong while removing product from cart.');
      }
    }
  }
);

// export const removeFromCart = createAsyncThunk(
//   'cartItem/removeFromCart',
//   async (productId: string, thunkApi) => {
//     try {
//       const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.RemoveCardItem}/${productId}`;
//       const { data } = await axios.delete(url, await getAPIConfig());

//       if (data.status === 200) {
//         return thunkApi.fulfillWithValue(data);
//       } else {
//         return thunkApi.rejectWithValue(data);
//       }
//     } catch (e) {
//       const error = e as AxiosError<ErrorResponse>;
//       if (error.response) {
//         return thunkApi.rejectWithValue(error.response.data);
//       } else {
//         return thunkApi.rejectWithValue('Something went wrong while removing product from cart.');
//       }
//     }
//   }
// );